import { Dispatch, Action } from "redux";

import { AxiosError } from "axios";

import * as toast from "./toasts";

export const toastMiddleware = () => (next: Dispatch) => async (action: Action) => {
    try {
        return await next(action);
    } catch (e) {
        const axiosError = e as AxiosError;
        let message = "";
        if (e.response && e.response.data && e.response.data.message) {
            message = e.response.data.message;
        } else {
            message = typeof e === "string" ? e : e.message;
        }
        if (axiosError.response && axiosError.response.status) {
            switch (axiosError.response.status) {
                case 400:
                    toast.error(message);
                    throw axiosError;  // TODO: Handle properly as per below when we build auth
                case 401:
                    toast.info("You have been logged out due to inactivity. Please log in again.");
                    throw axiosError;  // TODO: Handle properly as per below when we build auth
                case 500:
                    toast.error("Something went wrong, please try again later.");
                    throw axiosError;
                default:
            }
        }

        if (axiosError.code === AxiosError.ERR_CANCELED)
        {
            message = "";
        }

        if (message)
        {
            toast.error(message);
        }

        throw e;
    }
};
